/* eslint-disable react-hooks/exhaustive-deps */
import Page from 'component/Page';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Tab, Tabs } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { ACCOUNT_ROLE_ADMIN } from 'util/permission';
import { selectCurrentUser } from 'redux/user/user.selector';
import sendRequest from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import { getParams, GUIDChecker, nNU, showToast, getServiceCode } from 'util/utils';
import ServiceCodeUsage from './ServiceCodeUsage';
import ServiceCodeAssignAppId from './ServiceCodeAssignAppId';
import ServiceCodeAssignChannel from './ServiceCodeAssignChannel';
import './ServiceCodeDetail.scss';

const SERVICE_CODE_DETAIL_TABS = {
	USAGE: 'usage',
	APPID: 'appid',
	CHANNEL: 'channel',
};

const ServiceCodeDetailTabs = {
	usage: {
		title: string.APP_SC_TAB_USAGE_TITLE,
		component: ServiceCodeUsage,
		// component: AssignCode,
	},
	appid: {
		title: string.APP_SC_TAB_APPID_TITLE,
		component: ServiceCodeAssignAppId,
	},
	channel: {
		title: string.APP_SC_TAB_CHANNEL_TITLE,
		component: ServiceCodeAssignChannel,
	},
};

const ServiceCodeDetail = ({data = {serviceCodeId: null}}) => {
	//-------------------------------HOOKS-------------------------------------------------------------
	const params = getParams();
	const [currentTab, setCurrentTab] = useState(
		params?.tab || SERVICE_CODE_DETAIL_TABS.USAGE,
		// params?.tab || SERVICE_CODE_DETAIL_TABS.APPID,
	);

	const currentUser = useSelector(selectCurrentUser);
	const isAdmin = useMemo(
		() => currentUser.accountRole === ACCOUNT_ROLE_ADMIN,
		[ currentUser.accountRole ]
	);
	const isMonitorOnly = useMemo(
		() => currentUser.isMonitorOnly === 1,
		[currentUser.isMonitorOnly]
	);

	const serviceCodeId = data.serviceCodeId || params?.serviceCodeId || params?.id;
	const [selectedCode, setSelectedCode] = useState(serviceCodeId);
	const [ serviceCode, setServiceCode ] = useState(null);

	//------------------------------FUNCTIONS----------------------------------------------------------
	if(isAdmin) {
		if(ServiceCodeDetailTabs.appid){
			delete ServiceCodeDetailTabs.appid;
		}
		if(ServiceCodeDetailTabs.channel){
			delete ServiceCodeDetailTabs.channel;
		}
	} else {
		if(!ServiceCodeDetailTabs.appid){
			ServiceCodeDetailTabs.appid = {
				title: string.APP_SC_TAB_APPID_TITLE,
				component: ServiceCodeAssignAppId,
			};
		}
		if(!ServiceCodeDetailTabs.channel){
			ServiceCodeDetailTabs.channel = {
				title: string.APP_SC_TAB_CHANNEL_TITLE,
				component: ServiceCodeAssignChannel,
			};
		}
	}

	useEffect(()=>{
		if(!nNU(selectedCode)){
			return;
		}
		sendRequest({
			url: `${Urls.servicecode.info}/${serviceCodeId}`,
			method: 'GET',
		}).then((response) => {
			const { result } = response;
			setServiceCode(result);
			// let volume = result?.volume - result?.volumeUsage;
			// setAssignableVolume(volume);
		}).catch((e) => {

		});
	},[ selectedCode ]);

/*
	useEffect(() => {
		if (!nNU(serviceCodeId)) {
			return;
		}
		sendRequest({
			url: `${Urls.servicecode.info}/${serviceCodeId}`,
			method: 'GET',
		}).then((response) => {
			const { result } = response;
			setServiceCode(result);
			let volume = result?.volume - result?.volumeUsage;
			setAssignableVolume(volume);
		}).catch((e) => {

		});
	}, [ serviceCodeId ]);
*/

	//-------------------------------RETURN------------------------------------------------------------
	return(
		<>
			<Page
				className="screen-service-code-detail"
				title={nNU(serviceCode?.code) ? `プリペイドコード【${getServiceCode(serviceCode?.code)}】`:''}
				body = {
					<>
						{/* <ServiceCodeUsage /> */}
						<Tabs activeKey={currentTab} onSelect={(t) => setCurrentTab(t)}>
							{Object.keys(ServiceCodeDetailTabs).map((t,index) => {
								let tab = ServiceCodeDetailTabs[t];
								let TabComponent = tab.component;
								if (!TabComponent) {
									return null;
								}
								return (
									<Tab key={index} eventKey={t} title={tab.title}>
										{currentTab === t && (
											<TabComponent serviceCodeId={selectedCode} />
										)}
									</Tab>
								);
							})}
						</Tabs>
					</>
				}
			/>
		</>
	);
};

export default ServiceCodeDetail;